export interface AmortizationRow {
    month: number;
    payment: number;
    balance: number;
    principal: number;
    interest: number;
    cumulativeInterest: number;
}

export function generateAmortizationSchedule(
    loanAmount: number,
    annualRate: number,
    loanTermYears: number,
): AmortizationRow[] {
    const monthlyRate = annualRate / 100 / 12;
    const totalPayments = loanTermYears * 12;
    const schedule: AmortizationRow[] = [];

    let balance = loanAmount;
    let cumulativeInterest = 0;

    const factor = Math.pow(1 + monthlyRate, totalPayments);
    const monthlyPayment = (loanAmount * monthlyRate * factor) / (factor - 1);

    schedule.push({
        month: 0,
        payment: 0,
        balance,
        principal: 0,
        interest: 0,
        cumulativeInterest: 0,
    });

    for (let month = 1; month <= totalPayments; month++) {
        const interest = balance * monthlyRate;
        const principal = monthlyPayment - interest;
        balance -= principal;
        cumulativeInterest += interest;

        schedule.push({
            month,
            payment: monthlyPayment,
            balance: Math.max(balance, 0),
            principal,
            interest,
            cumulativeInterest,
        });
    }

    return schedule;
}
